import React, {useState} from "react";
import ConfirmationDialog from "@/lib/components/ConfirmationDialog";
import {CommonI18N, OrderI18N} from "@/translations";
import {useTranslation} from "react-i18next";
import StringInputField from "@/lib/components/inputfields/string-input-field";
import {Constants} from "@/api/constants";

interface OrderCancellationDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: (reason: string) => void;
}

/**
 * Dialog for cancelling an order with a mandatory reason field.
 * The confirm button is disabled until the user enters a non-empty reason.
 */
const OrderCancellationDialog: React.FC<OrderCancellationDialogProps> = ({ open, onClose, onConfirm }) => {
    const { t } = useTranslation();
    const [reason, setReason] = useState("");

    const handleConfirm = () => {
        onConfirm(reason);
        setReason("");
    };

    const handleClose = () => {
        setReason("");
        onClose();
    };

    return (
        <ConfirmationDialog
            open={open}
            onClose={handleClose}
            onConfirm={handleConfirm}
            title={t(OrderI18N.cancellation.dialog.title)}
            message={t(OrderI18N.cancellation.dialog.message)}
            confirmButtonText={t(OrderI18N.cancellation.action.confirm)}
            cancelButtonText={t(CommonI18N.action.cancel)}
            confirmDisabled={!reason.trim()}
            autoFocusConfirm={false}
            closeOnConfirm
        >
            <StringInputField
                    label={t(OrderI18N.cancellation.field.reason)}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                multiline
                maxChars={Constants.CANCELLATION_REASON_LENGTH_MAX}
                sx={{ mt: 2, width: "100%" }}
            />
        </ConfirmationDialog>
    );
};

export default OrderCancellationDialog;
